import React from 'react'


const KiwiAd = props =><a target="_blank" rel="noopener noreferrer" href="https://c1.travelpayouts.com/click?shmarker=88997&promo_id=3403&source_type=banner&type=click"><img src="https://c1.travelpayouts.com/content?promo_id=3403&shmarker=88997&type=init" alt="240х400_англ." width="240" height="400"/></a>;


export default KiwiAd;


